import { render, staticRenderFns } from "./jiancenengliDetail.vue?vue&type=template&id=6baf3e29&scoped=true"
import script from "./jiancenengliDetail.vue?vue&type=script&lang=js"
export * from "./jiancenengliDetail.vue?vue&type=script&lang=js"
import style0 from "./jiancenengliDetail.vue?vue&type=style&index=0&id=6baf3e29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf3e29",
  null
  
)

export default component.exports